import { NIcon } from '@innersource-nn/novoui-react';
import clsx from 'clsx';

interface StatusInfoTabProps {
    error?: boolean;
    child: string;
    parent: string;
    message?: string;
}
export default function StatusInfoTab({
    error,
    child,
    parent,
    message,
}: StatusInfoTabProps) {
    return (
        <div className="empty-place-holder mt-12">
            <div className="flex flex-col items-center">
                <div
                    className={clsx(
                        error ? 'bg-lava-red-200' : 'bg-light-blue-200',
                        'round-div-icon-middle  h-[88px]	w-[88px] ',
                    )}
                >
                    <NIcon
                        iconName={error ? 'warning' : 'book'}
                        size={48}
                        className="fill-true-blue"
                    />
                </div>
                <p className="text-true-blue text-center mt-8">
                    {error
                        ? `Error: Something went wrong while trying to load the ${child}. Please close and open the ${parent} again.`
                        : `There are currently no ${child} in this ${parent}.`}
                    {message}
                </p>
            </div>
        </div>
    );
}
